(function () {
  'use strict';

  if (window.CleerdentSubscriptionBundleGuard) return;

  var nativeFetch = window.fetch ? window.fetch.bind(window) : null;
  var nativeXhrOpen = window.XMLHttpRequest && window.XMLHttpRequest.prototype.open;
  var nativeXhrSend = window.XMLHttpRequest && window.XMLHttpRequest.prototype.send;
  var validationPromise = null;
  var validationQueued = false;
  var validationTimer = null;
  var internalMutation = false;
  var checkoutValidationInProgress = false;

  if (!nativeFetch) return;

  function rootUrl() {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    root = root || '/';
    return root.slice(-1) === '/' ? root : root + '/';
  }

  function cartUrl(path) {
    return rootUrl() + String(path || '').replace(/^\//, '');
  }

  function requestUrl(input) {
    if (typeof input === 'string') return input;
    if (input && typeof input.url === 'string') return input.url;
    return '';
  }

  function isCartMutationUrl(input) {
    var value = requestUrl(input);
    if (!value) return false;

    try {
      value = new URL(value, window.location.href).pathname;
    } catch (error) {
      value = value.split('?')[0];
    }

    return /\/cart\/(add|change|update|clear)(\.js)?\/?$/i.test(value);
  }

  function sellingPlanId(item) {
    var allocation = item && item.selling_plan_allocation;
    var plan = allocation && allocation.selling_plan;
    return plan && plan.id != null ? String(plan.id) : '';
  }

  function positiveQuantity(item) {
    var quantity = parseInt(item && item.quantity, 10);
    return Number.isFinite(quantity) && quantity > 0 ? quantity : 0;
  }

  function isUnpairedFreeFirstPlan(item) {
    var allocation = item && item.selling_plan_allocation;
    var adjustments = allocation && allocation.price_adjustments;
    if (!Array.isArray(adjustments) || adjustments.length < 2) return false;

    var firstPrice = Number(adjustments[0] && adjustments[0].price);
    var recurringPrice = Number(adjustments[1] && adjustments[1].price);
    return Number.isFinite(firstPrice) && firstPrice === 0 && Number.isFinite(recurringPrice) && recurringPrice > 0;
  }

  function bundleDescriptor(item) {
    var properties = (item && item.properties) || {};
    var descriptor = {
      role: String(properties._cd_bundle_role || ''),
      token: String(properties._cd_bundle_token || ''),
      mainProductId: String(properties._cd_bundle_main_product_id || ''),
      mainPlanId: String(properties._cd_bundle_main_plan_id || ''),
      addonVariantId: String(properties._cd_bundle_addon_variant_id || ''),
      addonPlanId: String(properties._cd_bundle_addon_plan_id || ''),
    };

    descriptor.marked = !!(
      descriptor.role ||
      descriptor.token ||
      descriptor.mainProductId ||
      descriptor.mainPlanId ||
      descriptor.addonVariantId ||
      descriptor.addonPlanId
    );
    descriptor.complete = !!(
      descriptor.token &&
      descriptor.mainProductId &&
      descriptor.mainPlanId &&
      descriptor.addonVariantId &&
      descriptor.addonPlanId &&
      (descriptor.role === 'main' || descriptor.role === 'addon')
    );
    descriptor.key = [
      descriptor.token,
      descriptor.mainProductId,
      descriptor.mainPlanId,
      descriptor.addonVariantId,
      descriptor.addonPlanId,
    ].join('::');

    return descriptor;
  }

  function lineMatchesDescriptor(item, descriptor) {
    if (!descriptor.complete) return false;

    if (descriptor.role === 'main') {
      return (
        String(item.product_id || '') === descriptor.mainProductId &&
        sellingPlanId(item) === descriptor.mainPlanId
      );
    }

    var variantId = item.variant_id != null ? item.variant_id : item.id;
    return String(variantId || '') === descriptor.addonVariantId && sellingPlanId(item) === descriptor.addonPlanId;
  }

  function correctionsFor(cart) {
    var mainQuantities = Object.create(null);
    var addonQuantities = Object.create(null);
    var protectedLines = [];
    var updates = {};
    var items = cart && Array.isArray(cart.items) ? cart.items : [];

    items.forEach(function (item) {
      var descriptor = bundleDescriptor(item);
      if (!descriptor.marked) {
        if (isUnpairedFreeFirstPlan(item)) updates[item.key] = 0;
        return;
      }

      if (!lineMatchesDescriptor(item, descriptor)) {
        updates[item.key] = 0;
        return;
      }

      var quantity = positiveQuantity(item);
      if (descriptor.role === 'main') {
        mainQuantities[descriptor.key] = (mainQuantities[descriptor.key] || 0) + quantity;
      } else {
        addonQuantities[descriptor.key] = (addonQuantities[descriptor.key] || 0) + quantity;
      }

      protectedLines.push({ item: item, descriptor: descriptor });
    });

    protectedLines.forEach(function (line) {
      var key = line.descriptor.key;
      var allowedQuantity = Math.min(mainQuantities[key] || 0, addonQuantities[key] || 0);
      var currentQuantity = positiveQuantity(line.item);
      if (allowedQuantity < currentQuantity) updates[line.item.key] = allowedQuantity;
    });

    return updates;
  }

  function hasCorrections(updates) {
    return Object.keys(updates).length > 0;
  }

  function updateCartCount(cart) {
    if (!cart || typeof cart.item_count === 'undefined') return;

    var count = Array.isArray(cart.items)
      ? cart.items.reduce(function (total, item) {
          var properties = item && item.properties;
          if (properties && properties._cleerdent_shipping_protection === 'true') return total;
          return total + positiveQuantity(item);
        }, 0)
      : Math.max(0, parseInt(cart.item_count, 10) || 0);

    document
      .querySelectorAll('[data-cart-count], .cart-count-bubble, .t4s-cart-count, .t4s-count-box')
      .forEach(function (node) {
        node.textContent = count;
        node.classList.toggle('is-empty', count === 0);
        if (node.hasAttribute('data-hide-empty')) node.hidden = count === 0;
      });

    document.querySelectorAll('.cd-hero-header__cart-link').forEach(function (link) {
      var bubble = link.querySelector('.cd-hero-header__cart-count');
      if (!bubble && count > 0) {
        bubble = document.createElement('span');
        bubble.className = 'cd-hero-header__cart-count';
        link.appendChild(bubble);
      }
      if (bubble) {
        bubble.textContent = count;
        bubble.hidden = count === 0;
      }
    });

    Array.prototype.slice.call(document.documentElement.classList).forEach(function (className) {
      if (/^t4s-cart-count-\d+$/.test(className)) document.documentElement.classList.remove(className);
    });
    document.documentElement.classList.add('t4s-cart-count-' + count);
  }

  function notifyTheme(cart, corrected) {
    updateCartCount(cart);

    var detail = {
      cart: cart,
      correctedBy: 'cleerdent-subscription-bundle-guard',
      removedOrAdjustedOffer: corrected === true,
    };

    ['cart:refresh', 'cart:updated', 'cart:update', 'theme:cart:change'].forEach(function (eventName) {
      document.dispatchEvent(new CustomEvent(eventName, { bubbles: true, detail: detail }));
      document.documentElement.dispatchEvent(new CustomEvent(eventName, { bubbles: true, detail: detail }));
    });

    if (window.jQuery) {
      window.jQuery(document.body).trigger('cart:refresh');
      window.jQuery(document.body).trigger('cart:updated', [cart]);
    }
  }

  function getCart() {
    return nativeFetch(cartUrl('cart.js'), {
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      credentials: 'same-origin',
    }).then(function (response) {
      if (!response.ok) throw new Error('Unable to validate the subscription bundle.');
      return response.json();
    });
  }

  function applyCorrections(updates) {
    internalMutation = true;

    return nativeFetch(cartUrl('cart/update.js'), {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      credentials: 'same-origin',
      body: JSON.stringify({ updates: updates }),
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Unable to correct an incomplete subscription bundle.');
        return response.json();
      })
      .finally(function () {
        internalMutation = false;
      });
  }

  function validateCart() {
    if (validationPromise) {
      validationQueued = true;
      return validationPromise;
    }

    validationPromise = getCart()
      .then(function (cart) {
        updateCartCount(cart);
        var updates = correctionsFor(cart);
        if (!hasCorrections(updates)) return { cart: cart, corrected: false };

        return applyCorrections(updates).then(function (updatedCart) {
          notifyTheme(updatedCart, true);
          document.dispatchEvent(
            new CustomEvent('cleerdent:subscription-bundle-corrected', {
              bubbles: true,
              detail: { cart: updatedCart },
            })
          );
          return { cart: updatedCart, corrected: true };
        });
      })
      .catch(function (error) {
        console.error('[CleerdentSubscriptionBundleGuard]', error);
        return { cart: null, corrected: false, error: error };
      })
      .finally(function () {
        validationPromise = null;
        if (validationQueued) {
          validationQueued = false;
          scheduleValidation(0);
        }
      });

    return validationPromise;
  }

  function scheduleValidation(delay) {
    window.clearTimeout(validationTimer);
    validationTimer = window.setTimeout(validateCart, typeof delay === 'number' ? delay : 80);
  }

  function checkoutTriggerFromEvent(event) {
    var target = event.target;
    if (!target || !target.closest) return null;
    return target.closest('a[href*="/checkout"], button[name="checkout"], input[name="checkout"]');
  }

  function validateBeforeCheckout(event) {
    var trigger = checkoutTriggerFromEvent(event);
    if (!trigger || checkoutValidationInProgress) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    checkoutValidationInProgress = true;
    trigger.setAttribute('aria-busy', 'true');

    validateCart()
      .then(function (result) {
        if (result.error) {
          window.alert('We could not validate the subscription bundle. Please refresh the cart and try again.');
          return;
        }
        window.location.assign(cartUrl('checkout'));
      })
      .finally(function () {
        checkoutValidationInProgress = false;
        trigger.removeAttribute('aria-busy');
      });
  }

  window.fetch = function () {
    var args = arguments;
    var cartMutation = isCartMutationUrl(args[0]);
    return nativeFetch.apply(window, args).then(function (response) {
      if (cartMutation && !internalMutation) scheduleValidation(60);
      return response;
    });
  };

  if (nativeXhrOpen && nativeXhrSend) {
    window.XMLHttpRequest.prototype.open = function (method, url) {
      this._cdBundleCartMutation = isCartMutationUrl(url);
      return nativeXhrOpen.apply(this, arguments);
    };

    window.XMLHttpRequest.prototype.send = function () {
      if (this._cdBundleCartMutation) {
        this.addEventListener('loadend', function () {
          if (!internalMutation) scheduleValidation(60);
        });
      }
      return nativeXhrSend.apply(this, arguments);
    };
  }

  document.addEventListener('click', validateBeforeCheckout, true);
  ['cart:refresh', 'cart:updated', 'cart:update', 'theme:cart:change'].forEach(function (eventName) {
    document.addEventListener(eventName, function () {
      if (!internalMutation) scheduleValidation(80);
    });
  });

  var api = { validate: validateCart, schedule: scheduleValidation, correctionsFor: correctionsFor };
  window.CleerdentSubscriptionBundleGuard = api;
  window.CleerdentGopodsSubscriptionGuard = api;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', validateCart, { once: true });
  } else {
    validateCart();
  }
})();
